/** 

=========================================================
* Vision UI PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

import { useState } from 'react';

// @mui material components
import Card from '@mui/material/Card';

// Vision UI Dashboard PRO React components
import VuiBox from 'components/VuiBox';
import VuiTypography from 'components/VuiTypography';
import VuiButton from 'components/VuiButton';
import VuiSelect from 'components/VuiSelect';

// Vision UI Dashboard PRO React example components
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Footer from 'examples/Footer';

// Report options
const reportOptions = [
  { label: 'Pulse Report 10/1/25', value: 'LfNXvzAW4FBnOymAPV98' },
  { label: 'Pulse Report 10/8/25', value: 'LfNXvzAW4FBnOymAPV98' }
];

function WeeklyReports() {
  const [selectedReport, setSelectedReport] = useState(reportOptions[0]);

  const handleReportChange = (selectedOption) => {
    setSelectedReport(selectedOption);
  };

  const handleExport = () => {
    console.log('Exporting report:', selectedReport);
    // Handle export logic here
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={1} sx={{ overflow: "visible", lineHeight: "1.2" }}>
        {/* Header with Breadcrumb */}
        <VuiBox mb={1}>
         
          <VuiBox display="flex" justifyContent="space-between" alignItems="center">
            <VuiTypography variant="h4" color="white" fontWeight="medium">
              Weekly Report
            </VuiTypography>
          </VuiBox>
        </VuiBox>

        {/* Report Selection and Export */}
        <VuiBox mb={2} display="flex" justifyContent="space-between" alignItems="center">
          <VuiBox width="400px">
            <VuiSelect
              value={selectedReport ? { value: selectedReport.value, label: selectedReport.label } : null}
              onChange={(selectedOption) => handleReportChange(selectedOption ? { value: selectedOption.value, label: selectedOption.label } : null)}
              options={reportOptions.map((option) => ({
                value: option.value,
                label: option.label
              }))}
              placeholder="Select a report"
              sx={{
                '& .react-select__control': {
                  backgroundColor: 'white',
                  border: '0.5px solid rgba(15, 21, 53, 0.3)',
                  borderRadius: '15px',
                  minHeight: '40px',
                  '&:hover': {
                    border: '0.5px solid rgba(15, 21, 53, 0.5)',
                  },
                },
                '& .react-select__value-container': {
                  padding: '0 16px',
                },
                '& .react-select__single-value': {
                  color: 'black',
                  fontSize: '12px',
                },
                '& .react-select__placeholder': {
                  color: '#a0aec0',
                  fontSize: '12px',
                },
                '& .react-select__indicator-separator': {
                  backgroundColor: 'rgba(15, 21, 53, 0.3)',
                },
                '& .react-select__dropdown-indicator': {
                  color: 'black',
                },
                '& .react-select__menu': {
                  backgroundColor: 'white',
                  border: '0.5px solid rgba(15, 21, 53, 0.3)',
                  borderRadius: '15px',
                },
                '& .react-select__option': {
                  backgroundColor: 'transparent',
                  color: 'black',
                  fontSize: '12px',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 117, 255, 0.1)',
                  },
                  '&--is-selected': {
                    backgroundColor: '#0075ff',
                    color: 'white',
                  },
                },
              }}
            />
          </VuiBox>
          
          <VuiButton
            variant="contained"
            color="info"
            onClick={handleExport}
            sx={{
              backgroundColor: '#0075ff',
              padding: '12px 24px',
              fontSize: '10px',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              borderRadius: '12px',
              '&:hover': {
                backgroundColor: '#0056b3',
              },
            }}
          >
            EXPORT
          </VuiButton>
        </VuiBox>

        {/* Report Content Card */}
        <Card sx={{ overflow: "visible", lineHeight: "1.2" , height: 'calc(100vh - 300px)',}}>
          <VuiBox p={1} sx={{ lineHeight: "1.2" }}>
            {/* Infogram Embed */}
            
              <iframe
                loading="lazy"
                src={`https://e.infogram.com/_/${selectedReport.value}?src=embed&embed_type=responsive_iframe`}
                title="PRISM Pulse Report - 13M Template"
                allowFullScreen
                allow="fullscreen"
                style={{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  top: '0px',
                  left: '0px',
                  border: 'none',
                  padding: '0px',
                  margin: '0px',
                }}
              />
           
          </VuiBox>
        </Card>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default WeeklyReports;
